import { Container } from 'ui';
import { Stack } from '@koob/margaret';
import { EditorField, SelectField, TextField } from 'components/Fields';
import { KoobInputSelectField } from '@koob/ui';
import TextFieldButton from '../../../../components/Fields/TextFieldButton';
import { EXPERIENCE_ACTIVITIES_SCHEMA } from '../Utilities/ExperienceValidationSchemas';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { getThemes } from 'api/node/themes';
import { getSegments } from 'api/node/segments';

export const ExperienceActivities = ({ isReadOnly = false }) => {
  const { t } = useTranslation('experiences');
  const [{ value: experienceType }, ,] = useField('type');

  return (
    <Container size="full">
      <Stack direction="column" gutterSize={1.5} size="full">
        {experienceType !== 'Program' && (
          <>
            <Stack gutterSize={1.5} size="full">
              <TextField
                label={t('form.pickUpPoint')}
                name="activity.pickUpPoint"
                disabled={isReadOnly}
              />

              <Stack
                gutterSize={0}
                style={{
                  flexWrap: 'wrap',
                  alignItems: 'stretch',
                }}
              >
                <TextFieldButton
                  type="number"
                  step="1"
                  label={t('form.pickUpPointTimeHour')}
                  name="activity.pickUpPointTimeHour"
                  content={'H'}
                  min="0"
                  max="23"
                  disabled={isReadOnly}
                />
                <TextFieldButton
                  type="number"
                  step="15"
                  label={t('form.pickUpPointTimeMin')}
                  name="activity.pickUpPointTimeMin"
                  content={'min'}
                  min="0"
                  max="59"
                  disabled={isReadOnly}
                />
              </Stack>
            </Stack>

            <Stack gutterSize={1.5} size="full">
              <TextField
                label={t('form.dropOffPoint')}
                name="activity.dropOffPoint"
                disabled={isReadOnly}
              />

              <Stack
                gutterSize={0}
                style={{
                  flexWrap: 'wrap',
                  alignItems: 'stretch',
                }}
              >
                <TextFieldButton
                  type="number"
                  step="1"
                  label={t('form.dropOffPointTimeHour')}
                  name="activity.dropOffPointTimeHour"
                  content={'H'}
                  min="0"
                  max="23"
                  disabled={isReadOnly}
                />
                <TextFieldButton
                  type="number"
                  step="15"
                  label={t('form.dropOffPointTimeMin')}
                  name="activity.dropOffPointTimeMin"
                  content={'min'}
                  min="0"
                  max="59"
                  disabled={isReadOnly}
                />
              </Stack>
            </Stack>
          </>
        )}

        <Stack
          gutterSize={0.5}
          size="full"
          style={{
            flexWrap: 'wrap',
            alignItems: 'stretch',
            justifyContent: 'space-between',
          }}
        >
          <Stack>
            <SelectField
              label={t('form.difficulty')}
              name="difficulty"
              valueField={'value'}
              options={[
                { label: t('form.beginner'), value: 'Beginner' },
                {
                  label: t('form.intermediate'),
                  value: 'Intermediate',
                },
                { label: t('form.advanced'), value: 'Advanced' },
                { label: t('form.expert'), value: 'Expert' },
              ]}
              disabled={isReadOnly}
            />
          </Stack>
        </Stack>

        <Stack gutterSize={1.5} size="full">
          <KoobInputSelectField
            label={t('form.segments')}
            name="segments"
            multiple
            query={getSegments}
            renderOption={({ displayName }) => displayName}
            renderValue={({ displayName }) => displayName}
            disabled={isReadOnly}
          />

          <KoobInputSelectField
            label={t('form.themes')}
            name="themes"
            multiple
            query={getThemes}
            renderOption={({ displayName }) => displayName}
            renderValue={({ displayName }) => displayName}
            disabled={isReadOnly}
          />
        </Stack>

        <Stack gutterSize={1.5} size="full">
          <EditorField
            name={'highlights'}
            label={t('form.highlights')}
            disabled={isReadOnly}
          />
          <EditorField
            name={'activity.freeVisitInformations'}
            label={t('form.freeVisitInformations')}
            disabled={isReadOnly}
          />
        </Stack>
      </Stack>
    </Container>
  );
};

export const getSchema = () => EXPERIENCE_ACTIVITIES_SCHEMA;
